"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isSameDay = _interopRequireDefault(require("date-fns/isSameDay"));

var _setYear = _interopRequireDefault(require("date-fns/setYear"));

var _setMonth = _interopRequireDefault(require("date-fns/setMonth"));

var _setDate = _interopRequireDefault(require("date-fns/setDate"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _Calendar = _interopRequireDefault(require("../Calendar"));

var _DateInput = _interopRequireDefault(require("./DateInput"));

var _PopoverCommon = require("../common/PropTypes/PopoverCommon");

var _DatePickerSt = require("./DatePicker.st.css");

var _constants = require("./constants");

var _context = require("../WixStyleReactEnvironmentProvider/context");

var _wixDesignSystemsLocaleUtils = require("wix-design-systems-locale-utils");

var _excluded = ["onFocus"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * DatePicker component
 *
 * ### Keyboard support
 * * `Left`: Move to the previous day.
 * * `Right`: Move to the next day.
 * * `Up`: Move to the previous week.
 * * `Down`: Move to the next week.
 * * `PgUp`: Move to the previous month.
 * * `PgDn`: Move to the next month.
 * * `Home`: Move to the previous year.
 * * `End`: Move to the next year.
 * * `Enter`/`Esc`/`Tab`: close the calendar. (`Enter` & `Esc` calls `preventDefault`)
 *
 */
var DatePicker = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(DatePicker, _React$PureComponent);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, DatePicker);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openCalendar", function () {
      if (!_this.state.isOpen && !_this.props.readOnly) {
        _this.setState({
          isOpen: true,
          isDateInputFocusable: false,
          value: _this.props.value || new Date()
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeCalendar", function () {
      _this.setState({
        isOpen: false
      }, function () {
        if (_this.props.onClose) {
          _this.props.onClose();
        }
      });
      /*
        to fix case when user press tab in opened Calendar and:
          1. Calendar become closed
          2. Focus triggered
          3. openCalendar triggered by focus
          4. Calendar become visible
          5. Looks like nothing happen
        We need to do such steps:
         1. Close calendar(with isDateInputFocusable: false)
         2. After calendar is closed, on next event loop(after focus is fired)  make isDateInputFocusable: focusable
         to allow user to press tab in future and open Calendar
      */


      setTimeout(function () {
        return _this.makeInputFocusable();
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "makeInputFocusable", function () {
      return _this.setState({
        isDateInputFocusable: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleInputChange", function (_ref) {
      var dateVal = _ref.dateVal,
          textVal = _ref.textVal;

      _this._saveNewValue(dateVal);

      _this.setState({
        inputValue: textVal
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidUpdate", function (prevProps) {
      var prevValue = prevProps.value;
      var newValue = _this.props.value;

      if (newValue !== prevValue) {
        if (newValue) {
          _this._saveNewValue(newValue);

          return _this.setState({
            inputValue: newValue
          });
        }

        var value = _this._transformDate(new Date(), prevValue);

        return _this.setState({
          inputValue: '',
          value: value
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_transformDate", function (value, oldValue) {
      return [[value.getFullYear(), _setYear["default"]], [value.getMonth(), _setMonth["default"]], [value.getDate(), _setDate["default"]]].reduce(function (_value, _ref2) {
        var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
            datePart = _ref3[0],
            setter = _ref3[1];

        return setter(_value, datePart);
      }, oldValue);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_saveNewValue", function (value) {
      var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (modifiers.disabled) {
        return;
      }

      var isChanged = !(0, _isSameDay["default"])(value, _this.props.value);

      if (isChanged) {
        var oldValue = _this.props.value || new Date(new Date().setHours(0, 0, 0, 0));

        var newValue = _this._transformDate(value, oldValue);

        _this.setState({
          value: newValue
        }, function () {
          return _this.props.onChange(newValue);
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleKeyDown", function (event) {
      // TODO: dirty for now
      if (!_this.state.isOpen) {
        _this.openCalendar();
      }
      /* keyHandler(this.state.value);*/

    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderInput", function () {
      var _this$props = _this.props,
          inputDataHook = _this$props.inputDataHook,
          disabled = _this$props.disabled,
          placeholderText = _this$props.placeholderText,
          readOnly = _this$props.readOnly,
          status = _this$props.status,
          statusMessage = _this$props.statusMessage,
          customInput = _this$props.customInput,
          _this$props$inputProp = _this$props.inputProps,
          inputProps = _this$props$inputProp === void 0 ? {} : _this$props$inputProp,
          size = _this$props.size,
          clearButton = _this$props.clearButton,
          onClear = _this$props.onClear,
          disableKeyboardType = _this$props.disableKeyboardType,
          dateStyle = _this$props.dateStyle;
      var _onFocus = inputProps.onFocus,
          inputPropsRest = (0, _objectWithoutProperties2["default"])(inputProps, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_DateInput["default"], (0, _extends2["default"])({
        dataHook: inputDataHook,
        className: _DatePickerSt.classes.input,
        value: _this.state.inputValue
        /* This line normally does nothing, because once clicked, component is already focused, hence onFocus
        kicks in and open the calendar.
        Why do we still keep this line? Backward compatibility for clients that test the component and simulate click
        without simulating focus first. */
        ,
        onInputClicked: _this.openCalendar,
        disabled: disabled,
        readOnly: readOnly,
        placeholder: placeholderText,
        onFocus: function onFocus(e) {
          _onFocus && _onFocus(e);

          _this.openCalendar(e);
        },
        onKeyDown: _this._handleKeyDown,
        tabIndex: _this.state.isDateInputFocusable ? 0 : -1,
        status: status,
        statusMessage: statusMessage,
        autoSelect: false,
        customInput: customInput,
        locale: _this._getLocale(),
        dateStyle: dateStyle,
        size: size,
        clearButton: clearButton,
        onClear: onClear,
        onChange: _this._handleInputChange,
        disableEditing: disableKeyboardType
      }, customInput ? customInput.props : {}, inputPropsRest));
    });
    var initialOpen = props.initialOpen && !props.disabled;
    _this.state = {
      value: props.value || new Date(),
      isOpen: initialOpen,
      isDateInputFocusable: !props.initialOpen,
      inputValue: props.value || ''
    };
    return _this;
  }

  (0, _createClass2["default"])(DatePicker, [{
    key: "_getLocale",
    value: function _getLocale() {
      return this.props.locale || this.context.locale || 'en';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          showMonthDropdown = _this$props2.showMonthDropdown,
          showYearDropdown = _this$props2.showYearDropdown,
          filterDate = _this$props2.filterDate,
          excludePastDates = _this$props2.excludePastDates,
          rtl = _this$props2.rtl,
          shouldCloseOnSelect = _this$props2.shouldCloseOnSelect,
          width = _this$props2.width,
          calendarDataHook = _this$props2.calendarDataHook,
          twoMonths = _this$props2.twoMonths,
          zIndex = _this$props2.zIndex,
          dataHook = _this$props2.dataHook,
          popoverProps = _this$props2.popoverProps,
          firstDayOfWeek = _this$props2.firstDayOfWeek,
          leftArrowAriaLabel = _this$props2.leftArrowAriaLabel,
          leftArrowAriaLabelledBy = _this$props2.leftArrowAriaLabelledBy,
          rightArrowAriaLabel = _this$props2.rightArrowAriaLabel,
          rightArrowAriaLabelledBy = _this$props2.rightArrowAriaLabelledBy,
          monthDropdownAriaLabel = _this$props2.monthDropdownAriaLabel,
          monthDropdownAriaLabelledBy = _this$props2.monthDropdownAriaLabelledBy,
          yearDropdownAriaLabel = _this$props2.yearDropdownAriaLabel,
          yearDropdownAriaLabelledBy = _this$props2.yearDropdownAriaLabelledBy,
          disableKeyboardType = _this$props2.disableKeyboardType;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          value = _this$state.value;

      var popoverUpdatedProps = _objectSpread({
        placement: rtl ? 'top-end' : 'top-start'
      }, popoverProps);

      var calendarProps = {
        dataHook: _constants.dataHooks.datePickerCalendar,
        className: _DatePickerSt.classes.calendar,
        locale: this._getLocale(),
        showMonthDropdown: showMonthDropdown,
        showYearDropdown: showYearDropdown,
        filterDate: filterDate,
        excludePastDates: excludePastDates,
        rtl: rtl,
        onChange: this._saveNewValue,
        onClose: this.closeCalendar,
        value: value,
        shouldCloseOnSelect: shouldCloseOnSelect,
        numOfMonths: twoMonths ? 2 : 1,
        firstDayOfWeek: firstDayOfWeek,
        leftArrowAriaLabel: leftArrowAriaLabel,
        leftArrowAriaLabelledBy: leftArrowAriaLabelledBy,
        rightArrowAriaLabel: rightArrowAriaLabel,
        rightArrowAriaLabelledBy: rightArrowAriaLabelledBy,
        monthDropdownAriaLabel: monthDropdownAriaLabel,
        monthDropdownAriaLabelledBy: monthDropdownAriaLabelledBy,
        yearDropdownAriaLabel: yearDropdownAriaLabel,
        yearDropdownAriaLabelledBy: yearDropdownAriaLabelledBy
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _DatePickerSt.st)(_DatePickerSt.classes.root, {
          disableKeyboardType: disableKeyboardType
        }, className),
        "data-hook": dataHook,
        style: {
          width: width
        }
      }, /*#__PURE__*/_react["default"].createElement(_Popover["default"], (0, _extends2["default"])({
        className: _DatePickerSt.classes.popover,
        dataHook: _constants.dataHooks.datePickerPopover,
        onClickOutside: this.closeCalendar,
        appendTo: "parent",
        shown: isOpen,
        zIndex: zIndex
      }, popoverUpdatedProps), /*#__PURE__*/_react["default"].createElement(_Popover["default"].Element, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DatePickerSt.classes.inputContainer,
        "data-hook": _constants.dataHooks.datePickerInputContainer
      }, this._renderInput())), /*#__PURE__*/_react["default"].createElement(_Popover["default"].Content, null, /*#__PURE__*/_react["default"].createElement("div", {
        "data-hook": calendarDataHook
      }, /*#__PURE__*/_react["default"].createElement(_Calendar["default"], calendarProps)))));
    }
  }]);
  return DatePicker;
}(_react["default"].PureComponent);

exports["default"] = DatePicker;
(0, _defineProperty2["default"])(DatePicker, "displayName", 'DatePicker');
(0, _defineProperty2["default"])(DatePicker, "defaultProps", {
  filterDate: function filterDate() {
    return true;
  },
  rtl: false,
  width: '150px',
  zIndex: 1,
  disabled: false,
  inputDataHook: _constants.dataHooks.datePickerInput,
  popoverProps: {
    zIndex: 1
  },
  disableKeyboardType: false,
  onChange: function onChange() {},
  dateStyle: 'short'
});
DatePicker.contextType = _context.WixStyleReactEnvironmentContext;
DatePicker.propTypes = {
  /** Specify a single CSS class name to be appended to the root element */
  className: _propTypes["default"].string,

  /** Applies as data-hook HTML attribute that can be used in the tests */
  dataHook: _propTypes["default"].string,

  /** Focus selected day automatically when component mounts or updates */
  autoFocus: _propTypes["default"].bool,

  /** Override a field with a custom input element. If you only need to pass custom props to the `<Input/>`, then use `inputProps` instead. */
  customInput: _propTypes["default"].node,

  /** Allows you to pass default Input component properties */
  inputProps: _propTypes["default"].object,

  /**
   ##### Add an indication under a specific date.
   Function returns the indication node of a specific date or null if this day doesn't have an indication.
   * - `param` {date: Date, isSelected: boolean }
   * - `date` - a date
   * - `isSelected` - whether this date is the selected date
   * - `return` {React.node} - the indication node of a specific date or null if this day doesn't have an indication.
  */
  dateIndication: _propTypes["default"].func,

  /** Specify date picker instance locale */
  locale: _propTypes["default"].oneOf(_wixDesignSystemsLocaleUtils.supportedWixlocales),

  /** Sets date format of locale */
  dateStyle: _propTypes["default"].oneOf(['short', 'medium']),

  /** Specify whether a field should be disabled or not */
  disabled: _propTypes["default"].bool,

  /** Specify whether past dates should be selectable or not */
  excludePastDates: _propTypes["default"].bool,

  /**
   * ##### Specify selectable dates:
   *  * `param` {Date} `date` - a date to check
   *  * `return` {boolean} - true if `date` should be selectable, false otherwise
   */
  filterDate: _propTypes["default"].func,

  /** Applies a data-hook HTML attribute for date picker input */
  inputDataHook: _propTypes["default"].string,

  /** Applies a data-hook HTML attribute for date picker calendar view */
  calendarDataHook: _propTypes["default"].string,

  /** Defines a placeholder of the field */
  placeholderText: _propTypes["default"].string,

  /** Specify whether RTL mode is enabled or not. When true, the keyboard navigation will be changed, meaning pressing on the right arrow will navigate to the previous day, and pressing on the left arrow will navigate to the next day. */
  rtl: _propTypes["default"].bool,

  /** Defines the selected date */
  value: _propTypes["default"].object,

  /** Specify whether the calendar will be initially visible or not */
  initialOpen: _propTypes["default"].bool,

  /** Controls the status of a field */
  status: _propTypes["default"].oneOf(['error', 'warning', 'loading']),

  /** Defines the status message to be displayed on status icon hover. If not given or empty, the tooltip won’t be shown. */
  statusMessage: _propTypes["default"].node,

  /** Sets the width of picker input in pixels or percentage */
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** Set a desired z-index for date picker popover */
  zIndex: _propTypes["default"].number,

  /** Allows you to pass popover properties. The default placement value depends on the rtl prop - would be 'top-start' when rtl=false and 'top-end' in case of rtl=ture. */
  popoverProps: _propTypes["default"].shape(_PopoverCommon.PopoverCommonProps),

  /** Specify the starting day of a week, allowing only from 0 to 6 (Sunday to Saturday). The default value is 1 which means Monday. */
  firstDayOfWeek: _propTypes["default"].oneOf([0, 1, 2, 3, 4, 5, 6]),

  /** Specifies the size of the input */
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),

  /** Specify whether date picker input is readOnly or not */
  readOnly: _propTypes["default"].bool,

  /** Sets today's date. The today indication is added automatically according to the user timezone but in some cases, we need the ability to add the today indication based on the business timezone. */
  today: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),

  /** Display a clear button (x) on a non-empty field */
  clearButton: _propTypes["default"].bool,

  /** Provides a callback function when  day in selected in the calendar */
  onChange: _propTypes["default"].func.isRequired,

  /** Displays clear button (X) on a non-empty input and calls callback with no arguments */
  onClear: _propTypes["default"].func,

  /** Defines a callback function that is  called whenever a user presses escape, clicks outside of the element or a date is selected and `shouldCloseOnSelect` is set. Receives an event as a first argument. */
  onClose: _propTypes["default"].func,

  /** Defines a callback function that is called with the date of the first day of the month whenever the user selects a month in the calendar */
  onMonthChange: _propTypes["default"].func,

  /** Disable typing the in the input. When true, choosing a date is possible only by picking from the calendar. Default: true.  */
  disableKeyboardType: _propTypes["default"].bool,

  /** Displays a selectable yearDropdown */
  showYearDropdown: _propTypes["default"].bool,

  /** Displays a selectable monthDropdown */
  showMonthDropdown: _propTypes["default"].bool,

  /** Specify whether the calendar closes on day selection */
  shouldCloseOnSelect: _propTypes["default"].bool,

  /** Defines a string value that labels the months dropdown in calendar header */
  monthDropdownAriaLabel: _propTypes["default"].string,

  /** Identifies the element that labels the months dropdown in calendar header */
  monthDropdownAriaLabelledBy: _propTypes["default"].string,

  /** Defines a string value that labels the years dropdown in calendar header */
  yearDropdownAriaLabel: _propTypes["default"].string,

  /** Identifies the element that labels the years dropdown in calendar header */
  yearDropdownAriaLabelledBy: _propTypes["default"].string,

  /** Defines a string value that labels the left arrow in calendar header */
  leftArrowAriaLabel: _propTypes["default"].string,

  /** Identifies the element that labels the left arrow in calendar header */
  leftArrowAriaLabelledBy: _propTypes["default"].string,

  /** Defines a string value that labels the right arrow in calendar header */
  rightArrowAriaLabel: _propTypes["default"].string,

  /** Identifies the element that labels the right arrow in calendar header */
  rightArrowAriaLabelledBy: _propTypes["default"].string
};